<template>
  <div :class="{ mbtop: isTop() }">
    <HeaderMember v-if="!isWebView()"></HeaderMember>
    <router-view class="header-fixed"></router-view>
    <div class="container _textright">
      <BtnPagetop></BtnPagetop>
    </div>
    <FooterMember></FooterMember>
  </div>
</template>

<script>
import { isWebView } from "@/utils/UserAgent";
import { setSctvTag } from "@/utils/ExternalScripts";
import BtnPagetop from "@/components/button/BtnPagetop";
import HeaderMember from "@/components/globals/HeaderMember";
import FooterMember from "@/components/globals/FooterMember";

export default {
  name: "MemberLayout",
  components: {
    HeaderMember,
    BtnPagetop,
    FooterMember,
  },
  mounted: function () {
    if (
      !window.__PRERENDER_INJECTED ||
      !window.__PRERENDER_INJECTED.isPrerendering
    ) {
      this.$gtm.enable(true);
      setSctvTag(this.$route.name);
    }
  },
  updated: function () {
    if (
      !window.__PRERENDER_INJECTED ||
      !window.__PRERENDER_INJECTED.isPrerendering
    ) {
      setSctvTag(this.$route.name);
    }
  },
  methods: {
    isTop: function () {
      return this.$route.name === "mb001";
    },
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.mbtop {
  @include mq-down(md) {
    padding-bottom: 50px;
  }
}
</style>
